export default __webpack_public_path__ + "static/media/machine-image.3c6bfb1c.png";